import React from 'react';
import { NavLink } from 'react-router-dom';

import { Breadcrumb } from '@shared/components/bootstrap';

import { useNavigate } from '@admin/hooks/use_navigate';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { Coupon__Input, useCouponCreateMutation } from '@admin/schema';

import { CouponForm } from './form';

export const New: React.FC = () => {
  useTitle('New Coupon');
  const [execute, { loading }] = useCouponCreateMutation({ client });
  const navigate = useNavigate();

  const onSave = () => {
    navigate('/marketing/coupons');
  };

  return (
    <>
      <div className="page-header">
        <Breadcrumb>
          <Breadcrumb.Item>
            <NavLink to="/marketing/coupons">Coupons</NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item>New</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <CouponForm
        onSave={onSave}
        loading={loading}
        save={(input: Coupon__Input) => execute({ variables: { input } })}
      />
    </>
  );
};
